/**
 * arrayTreeFilter.js
 *
 * @Author: zhangce
 * @Date: 17/8/31 上午11:09
 */
import { isFunction } from './isType';

const arrayTreeFilter = (data, filterFn, getChildren, options = {}) => {
  options.childrenKeyName = options.childrenKeyName || 'children';
  const children = data || [];
  const result = [];
  let level = 0;
  const filterCallBack = item => filterFn(item, level);
  const getFilterItem = children => {
    const foundItem = children.filter(filterCallBack)[0];
    if (!foundItem) {
      return false;
    }
    const newChildren =
      (isFunction(getChildren) ? getChildren(foundItem) : foundItem[options.childrenKeyName]) || [];
    result.push(foundItem);
    level++;
    newChildren.length && getFilterItem(newChildren);
  };

  getFilterItem(children);

  return result;
};

const treeToPath = (tree, path = [], currentPath = [], options = {}) => {
  options.childrenKeyName = options.childrenKeyName || 'children';
  tree.forEach((item, index) => {
    const children = item[options.childrenKeyName];
    if (index !== 0) {
      currentPath.pop();
    }
    currentPath.push(item);
    if (children && children.length) {
      treeToPath(item[options.childrenKeyName], path, currentPath, options);
    } else {
      path.push(currentPath.slice(0));
    }
  });
  currentPath.pop();

  return path;
};

export { arrayTreeFilter, treeToPath };



// WEBPACK FOOTER //
// ./src/util/arrayTreeFilter.js